import { useCallback, useRef, useState } from 'react';

export const useResizeObserver = <T extends HTMLElement>() => {
    const [size, setSize] = useState({ width: 0, height: 0 });
    const observerRef = useRef<ResizeObserver | null>(null);
    const elementRef = useRef<T | null>(null);

    const ref = useCallback((node: T | null) => {
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }

        if (node) {
            elementRef.current = node;

            observerRef.current = new ResizeObserver(([entry]) => {
                const { width, height } = entry?.contentRect || {
                    width: 0,
                    height: 0,
                };

                setSize({ width, height });
            });

            observerRef.current.observe(node);
        }
    }, []);

    return { ref, size };
};
